export const makeFirstLetterLowerCase = (string: string): string => (
  string.charAt(0).toLowerCase() + string.slice(1)
);
